import React, {Component, Fragment} from 'react'
import {Collapse} from 'antd'
import InfoText from '../../../../../../elements/InfoText'
import Overview from './Overview'
import BillLinesList from './BillLines/BillLinesList'

const {Panel} = Collapse

class Details extends Component {
  render() {
    return (
      <Fragment>
        <Collapse bordered={false} defaultActiveKey={['overview', 'items']}>
          <Panel header={<h3>Overview</h3>} key="overview">
            <Overview {...this.props} />
          </Panel>
          <Panel header={<h3>Billable Items</h3>} key="items">
            <BillLinesList {...this.props} />
          </Panel>
        </Collapse>
        <InfoText
          text={
            'To Update Invoice Details please click on Update Button above.'
          }
        />
      </Fragment>
    )
  }
}

Details.propTypes = {}
Details.defaultProps = {}

export default Details
